module.exports = __webpack_public_path__ + "img/zhonggai.79463dd9.png";